import { mapState } from "vuex";
export const dataIndexMixins = {
  computed: {
    dataTopBarList() {
      let topbarList = [
        {
          name: "数据分析",
          isActive: false,
          path: "/data",
          icon:require("@/assets/img/menuIcons/icon-data.png")
        },
        {
          name: "商品分析",
          isActive: false,
          path: "/data/goods",
          icon:require("@/assets/img/menuIcons/icon-datagoods.png")
        },
        {
          name: "退增商品分析",
          isActive: false,
          path: "/data/goodsSale",
          icon:require("@/assets/img/menuIcons/icon-datagoodsSale.png")
        },
        {
          name: "会员数据",
          isActive: false,
          path: "/data/menberData",
          icon:require("@/assets/img/menuIcons/icon-datamenberData.png")
        },
        {
          name: "经营驾驶舱",
          isActive: false,
          path: "/data/goManage",
          icon:require("@/assets/img/menuIcons/icon-datagoManage.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
        if (val.childrenPath) {
          if (~val.childrenPath.indexOf(this.$route.path)) {
            val.isActive = true;
          }
        }
      });
      return topbarList;
    },
  },
}
